import { render, staticRenderFns } from "./FoodSafetyReportList.vue?vue&type=template&id=00d64360&scoped=true"
import script from "./FoodSafetyReportList.vue?vue&type=script&lang=js"
export * from "./FoodSafetyReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d64360",
  null
  
)

export default component.exports